import { Text } from '@bitrise/bitkit';
import { DateTime } from 'luxon';
import React, { FunctionComponent, useContext } from 'react';

import { AuthContextTrace } from '../Authenticate/AuthenticateTrace';
import { URLStateContext } from '../URLState/URLState';

const getTimeOfDay = (snapshotDate: Date): 'morning' | 'afternoon' | 'evening' => {
  const { hour } = DateTime.fromJSDate(snapshotDate);

  if (hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';

  return 'evening';
};

const OverviewIntro: FunctionComponent = () => {
  const { overviewPeriod } = useContext(URLStateContext);
  const {
    data: { appTitle },
  } = useContext(AuthContextTrace);

  const timeOfDay = getTimeOfDay(new Date());

  return (
    <Text size="x3">
      Good {timeOfDay}, here is your {overviewPeriod} briefing for {appTitle} in the key areas of
      performance, stability and usage. Please dive into each segment for more details.
    </Text>
  );
};

export default OverviewIntro;
